<script lang="ts" setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { ShiftCMSState } from '@/store';
import AppUser from '@/components/AppUser.vue';
import AppMenu from '@/components/AppMenu.vue';
import AppNotifications from '@/components/AppNotifications.vue';
import AppDrawer from '@/components/AppDrawer.vue';
import { User } from '@/models/user.model';

const store = useStore<ShiftCMSState>();
const auth = computed<string>(() => store.state.token);
const user = computed<User | null>(() => store.state.loggedInUser);
</script>
<template>
  <v-app>
    <AppMenu v-if="auth && user" />
    <AppUser />
    <v-main>
      <router-view />
    </v-main>
    <AppNotifications />
    <AppDrawer />
  </v-app>
</template>
